/**
 * 指标库「数据指标」多选：与 el-option :value 对齐、与接口回填结构兼容
 */

/** 将各类历史结构统一为 { dataIndicator } */
export function normalizeSelectedIndicatorListRows (list) {
  if (!Array.isArray(list)) return []
  return list.map((row) => {
    if (row == null || row === '') return { dataIndicator: '' }
    if (typeof row !== 'object') return { dataIndicator: row }
    const d = row.dataIndicator
    if (d !== undefined && d !== null && d !== '') {
      return { ...row, dataIndicator: d }
    }
    if (row.indicatorId !== undefined && row.indicatorId !== null && row.indicatorId !== '') {
      return { ...row, dataIndicator: row.indicatorId }
    }
    if (row.value !== undefined && row.value !== null && row.value !== '') {
      return { ...row, dataIndicator: row.value }
    }
    return { ...row, dataIndicator: '' }
  })
}

/** 解析 JSON 字符串并规范化行（编辑/查看大屏回填用） */
export function coerceSelectedIndicatorListOnChartViewData (chartViewData) {
  if (!chartViewData || typeof chartViewData !== 'object') return
  let sil = chartViewData.selectedIndicatorList
  if (typeof sil === 'string') {
    try {
      sil = JSON.parse(sil || '[]')
    } catch (e) {
      sil = []
    }
  }
  if (!Array.isArray(sil)) sil = []
  chartViewData.selectedIndicatorList = normalizeSelectedIndicatorListRows(sil)
}

/**
 * 将已选 id 与下拉项 value 对齐（避免 number / string 不一致导致 el-select 不回显）
 * @param {import('vue').default} vm 组件实例（需 $set）
 * @param {object} component 大屏组件对象
 */
export function alignSelectedIndicatorsWithOptionValues (vm, component) {
  const opts = component?.dataIndicatorList
  const sil = component?.chartViewData?.selectedIndicatorList
  if (!vm || !Array.isArray(opts) || opts.length === 0 || !Array.isArray(sil)) return
  sil.forEach((row, i) => {
    if (!row || row.dataIndicator === '' || row.dataIndicator == null) return
    const m = opts.find(o => String(o.value) === String(row.dataIndicator))
    if (m && row.dataIndicator !== m.value) {
      vm.$set(sil, i, { ...row, dataIndicator: m.value })
    }
  })
}
